export const SOFTWARE_PRODUCT = 'software';
export const projectSettingsUrl = (product: string) =>
	`/jira/${product}/projects/:projectKey/settings`;
export const boardSettingsUrl = (product: string) =>
	`${projectSettingsUrl(product)}/boards/:boardId`;
